import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import {
  Box,
  Typography
} from '@mui/material';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import React from 'react';
import {SupportSlotDefinitionCustomerAssignmentModel} from '../../../../model/support/slot/support-slot-definition-customer-assignment.model';
import {UniversalInput} from '../../shared/UniversalInput';

const days = ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"];

export type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void
  slotDefinitionAssignment: SupportSlotDefinitionCustomerAssignmentModel
  onSlotAssignmentDeleted: (slotDefinitionAssignmentId: string, version: number) => Promise<void>
  translate: (key: string) => string
}

export const SupportPlanSlotPreviewDrawer = ({slotDefinitionAssignment, isDrawerOpen, onDrawerClosed, translate, onSlotAssignmentDeleted}: Props) => {
  const buildStartTime = () => <UniversalInput
    label="Godzina rozpoczecia slotu"
    type="time"
    value={slotDefinitionAssignment.startTime}
    disabled={true}
    onChange={(val) => {
    }}
    min={0}
    step={1}
  />

  const buildEndTime = () => <UniversalInput
    label="Godzina zakończenia slotu"
    type="time"
    value={slotDefinitionAssignment.endTime}
    disabled={true}
    onChange={(val) => {
    }}
    min={0}
    step={1}
  />

  const buildValidFrom = () => <UniversalInput
    label="Aktywny od"
    type="date"
    value={slotDefinitionAssignment.validFrom}
    disabled={true}
    onChange={(val) => {
    }}
    min={0}
    step={1}
  />

  const buildValidTo = () => <UniversalInput
    label="Aktywny do"
    type="date"
    value={slotDefinitionAssignment.validTo}
    disabled={true}
    onChange={(val) => {
    }}
    min={0}
    step={1}
  />

  const buildForm = () => <form onSubmit={async (event) => {
    event.preventDefault();
    await onSlotAssignmentDeleted(slotDefinitionAssignment.id, slotDefinitionAssignment.version)
    onDrawerClosed();
  }}
  >
    <Stack spacing={3}>
      {buildStartTime()}
      {buildEndTime()}
      {buildValidFrom()}
      {buildValidTo()}
      <Button type="submit"
              variant="outlined"
              color="error"
      >
        Usuń slot
      </Button>
    </Stack>
  </form>

  return <Drawer
    anchor="right"
    open={isDrawerOpen}
    onClose={onDrawerClosed}
    PaperProps={{
      sx: {
        width: 480,
        marginTop: '34px',
        height: `calc(100%)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <Box
      sx={{
        mb: 3,
        mt: 1,
        pb: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, mt: 1 }}>
        <CalendarTodayIcon fontSize="small" color="action" />
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {days[slotDefinitionAssignment.weekday - 1]} {slotDefinitionAssignment.startTime?.substring(0, 5)} - {slotDefinitionAssignment.endTime?.substring(0, 5)} | {translate(`support.slot.assignment.type.${slotDefinitionAssignment.assignmentType}`)}
        </Typography>
      </Box>
    </Box>
    {buildForm()}
  </Drawer>
}